module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/today-news-default-8430b9a0d5f16e43c181bc41c0ba683c.png";